import { useNotificationContext } from "@circle-react-shared/Notifications/NotificationContext";
import { useNotificationTabs } from "@circle-react-shared/Notifications/useNotificationTabs";

import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

import { NotificationTabsLegacy } from "./NotificationTabsLegacy";
import { NotificationTabsV4 } from "./NotificationTabsV4";

interface BodyProps {
  tabsContainerRef: (node: HTMLDivElement | null) => void;
  tabsContainerWidth: number;
}

export const Body = ({ tabsContainerWidth, tabsContainerRef }: BodyProps) => {
  const { activeTab, setActiveTab } = useNotificationContext();
  const isV4Tabs = useIsCircleV4FeatureEnabled("circle_v4_tabs_enabled");
  const tabs = useNotificationTabs();

  if (isV4Tabs) {
    return (
      <NotificationTabsV4
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        tabsContainerRef={tabsContainerRef}
        tabsContainerWidth={tabsContainerWidth}
      />
    );
  }

  return (
    <NotificationTabsLegacy
      tabs={tabs}
      activeTab={activeTab}
      onTabChange={setActiveTab}
      tabsContainerRef={tabsContainerRef}
      tabsContainerWidth={tabsContainerWidth}
    />
  );
};
